import React from 'react';

interface LogoProps {
    size?: number;
    className?: string;
}

/** Animated Perceptya logo SVG — used in Header and Footer */
export const Logo: React.FC<LogoProps> = ({ size = 32, className = '' }) => (
    <svg
        className={`nav-logo-mark ${className}`}
        width={size}
        height={size}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {/* Hexagon outline */}
        <polygon
            points="50,5 91.65,26.5 91.65,73.5 50,95 8.35,73.5 8.35,26.5"
            stroke="#FF6B2B" strokeWidth="2" fill="none" strokeOpacity="0.7"
        />
        {/* Brain left hemisphere */}
        <path
            d="M50,30 C38,30 30,38 30,50 C30,62 38,70 50,70"
            stroke="#FF6B2B" strokeWidth="2.5" fill="none" strokeLinecap="round"
        />
        {/* Brain right hemisphere */}
        <path
            d="M50,30 C62,30 70,38 70,50 C70,62 62,70 50,70"
            stroke="#FF6B2B" strokeWidth="2.5" fill="none" strokeLinecap="round"
        />
        {/* Circuit lines */}
        <line className="logo-circuit-1" x1="50" y1="30" x2="50" y2="70" stroke="#FF6B2B" strokeWidth="1.5" strokeOpacity="0.5" />
        <line className="logo-circuit-2" x1="33" y1="44" x2="50" y2="44" stroke="#FF6B2B" strokeWidth="1.5" strokeOpacity="0.5" />
        <line className="logo-circuit-3" x1="33" y1="56" x2="50" y2="56" stroke="#FF6B2B" strokeWidth="1.5" strokeOpacity="0.5" />
        <line className="logo-circuit-2" x1="50" y1="44" x2="67" y2="44" stroke="#FF6B2B" strokeWidth="1.5" strokeOpacity="0.5" />
        <line className="logo-circuit-3" x1="50" y1="56" x2="67" y2="56" stroke="#FF6B2B" strokeWidth="1.5" strokeOpacity="0.5" />
        {/* Neural nodes */}
        <circle className="logo-node-1" cx="50" cy="50" r="3" fill="#FF6B2B" />
        <circle className="logo-node-2" cx="38" cy="44" r="2" fill="#FF6B2B" />
        <circle className="logo-node-3" cx="62" cy="56" r="2" fill="#FF6B2B" />
        <circle className="logo-node-2" cx="38" cy="56" r="2" fill="#FF6B2B" />
        <circle className="logo-node-3" cx="62" cy="44" r="2" fill="#FF6B2B" />
        {/* Orbital ring — spins via CSS class */}
        <circle className="logo-orbit" cx="50" cy="50" r="42" stroke="#FF6B2B" strokeWidth="1.2" strokeDasharray="5 3.5" strokeOpacity="0.35" />
        {/* Satellite dot — pulses via CSS class */}
        <circle className="logo-pulse" cx="50" cy="5" r="3" fill="#FF6B2B" />
    </svg>
);

export default Logo;
